import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  @Input() data: any;
  @Input() tableHead;
  @Input() pagination: boolean = false;
  @Input() sorting: boolean = false;
  @Input() filter: number = 0;
  @Input() pageSizeOptions = [5, 10, 25, 100];
  @Input() isClickable = false;
  @Input() singleRowSelect = true;
  @Input() clickable = [3, 'view'];
  @Input() maxHeight = "300px";
  @Input() editDeleteEnable = false;
  @Input() editEnable = false;
  @Input() stickyValue;
  @Output() rowClicked = new EventEmitter<['', '']>();
  @Output() editDeleteClicked = new EventEmitter();
  @Output() multipleRowClicked = new EventEmitter();
  columnIds;
  propertyIds;
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  editKeyText = 'edit';
  deleteKeyText = 'delete';
  viewKeyText = 'view';
  ngOnInit() {
    this.dataSource = new MatTableDataSource<any>(this.data);
    //console.log(this.dataSource,"ffffffffffffffff")
  }
  ngAfterViewInit() {
    // console.log("this.tableHead", this.tableHead)
    // console.log("this.dataSource", this.dataSource)
  }
  ngOnChanges() {
    this.dataSource = new MatTableDataSource<any>(this.data);
    //console.log(this.dataSource,'ddddddddddddd')
    if (this.tableHead) {
      this.columnIds = this.tableHead.map(c => c.labelValue);
      if (this.isClickable) {
        this.columnIds = [...this.columnIds, 'actions']
      }
      if (this.editDeleteEnable) {
        this.columnIds = [...this.columnIds, 'actions']
      }
      if (this.editEnable) {
        this.columnIds = [...this.columnIds, 'actions']
      }
      if(this.stickyValue){
      this.columnIds = this.tableHead.map(c => c.labelValue);
      }
      setTimeout(() => {
        if (this.pagination) {
          this.dataSource.paginator = this.paginator;
        }
        if (this.sorting) {
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (item, property) => {
            let a = "";
            this.tableHead.forEach(element => {
              if (element.labelValue == property) {
                a = element.dataId;
              }
            })
            return item[a]
          }
        }
      });
      // console.log(this.data, "dataSource")
      // console.log(this.columnIds, "columnIds")
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); //.dataSourcesource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  clicked(row) {
    this.rowClicked.emit(row);
    console.log(row)
  }
  clickEditorDelete(row, action) {
    this.editDeleteClicked.emit({ action: action, value: row });

  }
  checkBox(event, row) {
    let a = { checked: event.checked, value: row }
    this.multipleRowClicked.emit(a)
  }
  onvalue(val) {
    if (typeof val === "string")
      return true;
    else
      return false;
  }


}
